import { createContext } from 'react';
export const DEFAULT_SQUAD = {
    users: [],
    teams: [],
    members: []
};
export const SquadContext = createContext(DEFAULT_SQUAD);
